import React, { useEffect, useState } from "react";
import { Dialog, PaperProps } from "@material-ui/core";
import { useApp } from "Providers/AppProvider";
import { ModalState } from "./helpers/createModal";

export const PRESENTAION_ELEMENT_ID = "planning-board-presentation";
export const DIALOG_ROOT_CLASS_NAME = "MuiDialog-root";

function Modal<T>(props: {
	/**
	 * TODO: Rename to `modalState` once all components are migrated to the new modal system.
	 */
	modalController: ModalController<T> | ModalState<T>;
	children?: JSX.Element | JSX.Element[] | null;
	size?: "xs" | "sm" | "md" | "lg" | "xl";
	isCloseDisabled?: boolean;
	fullScreen?: boolean;
	PaperProps?: Partial<PaperProps>;
}) {
	const { scrollElement } = useApp();

	useEffect(() => {
		if (scrollElement) {
			scrollElement.style.overflowY = props.modalController.isOpen
				? "hidden"
				: "scroll";

			return () => {
				scrollElement.style.overflowY = "scroll";
			};
		}
	}, [props.modalController.isOpen, scrollElement]);

	return (
		<Dialog
			open={
				true /* Do not use  `modalController.isOpen` to support correct tracking! */
			}
			PaperProps={props.PaperProps}
			onClose={() => props.modalController.close()}
			maxWidth={props.size}
			disableEscapeKeyDown={props.isCloseDisabled}
			disableBackdropClick={props.isCloseDisabled}
			fullScreen={props.fullScreen}
			disableEnforceFocus
			disablePortal
			disableAutoFocus
			fullWidth
		>
			{props.children}
		</Dialog>
	);
}

export default Modal;

export interface ModalController<T> {
	isOpen: boolean;
	open: (openedItem?: T, isNew?: boolean) => void;
	close: (id?: string) => void;
	item?: T;
	isNew?: boolean;
}

export function useModalController<T>(props?: {
	isDefaultOpen?: boolean;
	isDefaultNew?: boolean;
	defaultItem?: T;
	onClose?: (id?: string) => void;
}) {
	const [isOpen, setIsOpen] = useState(!!props?.isDefaultOpen);
	const [isNew, setIsNew] = useState(!!props?.isDefaultNew);
	const [item, setItem] = useState(props?.defaultItem);

	const modalController: ModalController<T> = {
		isOpen,
		isNew,
		item,
		open: (openedItem?: T, isNew?: boolean) => {
			setItem(openedItem);
			setIsOpen(true);
			setIsNew(!!isNew);
		},
		close: (id?: string) => {
			setIsOpen(false);
			void props?.onClose?.(id);
		},
	};

	return modalController;
}
